import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Spinner } from "@phosphor-icons/react";
import { BookingScreen } from "@/components/nextmove/BookingForm";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Landing spot for the "talk through your insights" follow-up email (prefilled booking).
export default function Insights() {
  const [params] = useSearchParams();
  const token = params.get("t");
  const [state, setState] = useState({ phase: token ? "loading" : "invalid" });

  useEffect(() => {
    if (!token) return;
    fetch(`${API}/next-move/insights/${encodeURIComponent(token)}`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((lead) => setState({ phase: "ready", lead }))
      .catch(() => setState({ phase: "invalid" }));
  }, [token]);

  return (
    <div className="min-h-screen paper-grain flex items-start md:items-center justify-center px-4 py-10">
      <div className="w-full max-w-2xl bg-cvc-cream rounded-2xl border border-cvc-border shadow-sm" data-testid="insights-page">
        <div className="px-7 md:px-10 pt-7 md:pt-10">
          <p className="text-xs tracking-[0.3em] uppercase font-body font-semibold text-cvc-red">Your Business Scaling Assessment</p>
        </div>
        {state.phase === "loading" && (
          <div className="flex items-center gap-3 p-10 font-body text-cvc-ink-soft"><Spinner className="animate-spin" /> Loading…</div>
        )}
        {state.phase === "invalid" && (
          <div className="p-7 md:p-10 font-body text-cvc-ink" data-testid="insights-invalid">
            <p>This link isn't valid anymore. You can still reach Jonathan at <strong>435-535-7000</strong>.</p>
            <Link to="/" className="mt-4 inline-block text-cvc-red underline underline-offset-4">Back to Cache Valley Consulting</Link>
          </div>
        )}
        {state.phase === "done" && (
          <div className="p-7 md:p-10 font-body text-cvc-ink" data-testid="insights-done">
            <p className="font-heading text-2xl text-cvc-navy">
              {state.bookedLabel ? `You're booked for ${state.bookedLabel}.` : "Thanks — Jonathan will reach out to confirm the time."}
            </p>
            {state.bookedLabel && <p className="mt-2 text-cvc-ink-soft">A calendar invite is on its way to your inbox.</p>}
            <Link to="/" className="mt-4 inline-block text-cvc-red underline underline-offset-4">Back to Cache Valley Consulting</Link>
          </div>
        )}
        {state.phase === "ready" && (
          <BookingScreen
            assessmentToken={token}
            prefill={{
              name: state.lead.name || "", business_name: state.lead.business_name || "",
              email: state.lead.email || "", phone: state.lead.phone || "",
            }}
            onDone={(label) => setState({ phase: "done", bookedLabel: label })}
          />
        )}
      </div>
    </div>
  );
}
